import axios from "axios";
import { Link } from "react-router-dom";

const handleLogout = async () => {
  const token = localStorage.getItem("token");

  try {
    await axios.post(
      `https://api.softmri.com/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (e) {
    console.log("Logout error", e);
  }

  localStorage.removeItem("token");
  window.location.href = "/"; // redirect to login
};

const StartBar = () => {
  return (
    <>
      <div className="startbar d-print-none">
        {/* start brand */}
        <div className="brand">
          <Link to="/profile" className="logo">
            <span>
              <img
                src="assets/images/logo-sm.png"
                alt="logo-small"
                className="logo-sm"
              />
            </span>
            <span>
              <img
                src="assets/images/logo-light.png"
                alt="logo-large"
                className="logo-lg logo-light"
              />
              <img
                src="assets/images/logo-dark.png"
                alt="logo-large"
                className="logo-lg logo-dark"
              />
            </span>
          </Link>
        </div>
        {/* end brand */}

        {/* start startbar-menu */}
        <div className="startbar-menu">
          <div
            className="startbar-collapse"
            id="startbarCollapse"
            data-simplebar
          >
            <div className="d-flex align-items-start flex-column w-100">
              {/* Navigation */}
              <ul className="navbar-nav mb-auto w-100">
                <li className="menu-label pt-0 mt-0">
                  <span>Main Menu</span>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/dashboard">
                    <i className="iconoir-home-simple menu-icon"></i>
                    <span>Dashboard</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#sidebarApplications"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarApplications"
                  >
                    <i className="iconoir-view-grid menu-icon"></i>
                    <span>Applications</span>
                  </a>
                  <div className="collapse" id="sidebarApplications">
                    <ul className="nav flex-column">
                      <li className="nav-item">
                        <Link className="nav-link" to="/user">
                          Category
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to="/transection">
                          Transection
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="nav-item">
                  <button
                    onClick={handleLogout}
                    className="nav-link btn btn-link text-danger"
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="startbar-overlay d-print-none"></div>
    </>
  );
};

export default StartBar;
